export default "__VITE_ASSET__CFAMa7U9__"